import { ExportUtil, AttributeExportFieldEditor, AttributeExportFieldModel } from '@leverege/ui-attributes';
import Enum from "./enum/index.js";
import ResourceEnum from "./resourceEnum/index.js";
import Device from "./device/PluginSetup.js";
import Parent from "./parent/index.js";
import RelationshipSetup from "./relationship/PluginSetup.js";
import ResourceImage from "./image/resourceImage/PluginSetup.js";
import Image from "./image/PluginSetup.js";
import BlueprintTableModelConfigurer from "./BlueprintTableModelConfigurer.js";
import BlueprintXYChartModelConfigurer from "./BlueprintXYChartModelConfigurer.js";
import BlueprintListModelConfigurer from "./BlueprintListModelConfigurer.js";
import BlueprintPieChartModelConfigurer from "./BlueprintPieChartModelConfigurer.js";
import ImageList from "./image/imageList/PluginSetup.js";
const install = molten => {
  // parent relationship
  molten.addPlugin('Molten.blueprintsProcessor', BlueprintTableModelConfigurer.BlueprintAnalyzer);
  molten.addPlugin('Molten.blueprintsProcessor', BlueprintListModelConfigurer.BlueprintAnalyzer);
  molten.addPlugin('Molten.blueprintsProcessor', BlueprintXYChartModelConfigurer.BlueprintAnalyzer);
  molten.addPlugin('XYChartModelConfigurer', BlueprintXYChartModelConfigurer.AggregationResultConfigurer);
  molten.addPlugin('Molten.blueprintsProcessor', BlueprintPieChartModelConfigurer.BlueprintAnalyzer);
  molten.addPlugin('XYChartModelConfigurer', BlueprintXYChartModelConfigurer.HistoryResultConfigurer);
  molten.addPlugin('XYChartModelConfigurer', BlueprintPieChartModelConfigurer.HistoryResultConfigurer);
  molten.addPlugin('XYChartModelConfigurer', BlueprintPieChartModelConfigurer.AggregationResultConfigurer);
  const strType = ExportUtil.getExportFieldTypeForType('parentRelationship');
  molten.addPlugin('Model', {
    type: strType,
    model: AttributeExportFieldModel.createFor(strType)
  });
  molten.addPlugin('ModelEditor', {
    type: strType,
    editor: AttributeExportFieldEditor
  });

  // enum
  Enum.install(molten);

  // resource enum
  ResourceEnum.install(molten);
  Device.install(molten);
  Parent.install(molten);
  RelationshipSetup.install(molten);
  ResourceImage.install(molten);
  Image.install(molten);
  ImageList.install(molten);
};
export default {
  install
};